import { ObjectHelper } from '../../../helpers/objectHelper';
import { EDuree } from "../models/eduree";

export class DurationTypeError extends Error {
	constructor(peDurationType: EDuree) {
		super(`Le type de durée '${peDurationType}' n'est pas reconnu.`);
		// Nécessaire pour que le 'instanceof DurationTypeError' fonctionne (fonctionne sans uniquement sur le tsPlayground).
		ObjectHelper.initInstanceOf(this, DurationTypeError);
	}
}